import { autoinject } from 'aurelia-dependency-injection';
import { TokenService } from './TokenService';
import { Tenant } from '../models';
import { HTTPService } from './HTTPService';

export class TenantServiceConfig {
  apiBaseUrl: string;
  tenantBucket: string;
}

@autoinject
export class TenantService {
  constructor(private config: TenantServiceConfig, private httpService: HTTPService, private tokenService: TokenService) { }

  async getTenant(id: string): Promise<Tenant> {
    const token = this.tokenService.getAccessToken();
    const tenant = await this.httpService.request({
      url: `${this.config.apiBaseUrl}/api/tenants/${id}`,
      headers: { Authorization: `Bearer ${token}` },
    });
    const logo = tenant.logo ? `${this.config.tenantBucket}/${tenant.logo}` : undefined;
    return { ...tenant, logo };
  }
}



// WEBPACK FOOTER //
// ./src/support/TenantService.ts